import React from 'react';
import { UrgencyBar } from '../components/UrgencyBar';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { StatsBar } from '../components/StatsBar';
import { ScenarioSection } from '../components/ScenarioSection';
import { PainPoints } from '../components/PainPoints';
import { ImpactQuote } from '../components/ImpactQuote';
import { ExplanationSection } from '../components/ExplanationSection';
import { MethodSection } from '../components/MethodSection';
import { ProductSection } from '../components/ProductSection';
import { BonusSection } from '../components/BonusSection';
import { PricingSection } from '../components/PricingSection';
import { ForWhoSection } from '../components/ForWhoSection';
import { AuthorSection } from '../components/AuthorSection';
import { FinalCTA } from '../components/FinalCTA';
import { FAQSection } from '../components/FAQSection';
export function LandingPage() {
  return <div className="min-h-screen bg-navy font-dmsans selection:bg-gold selection:text-navy" data-id="element-175">
      <UrgencyBar data-id="element-176" />
      <Navbar data-id="element-177" />
      <main className="pt-[72px]" data-id="element-178">
        {' '}
        {/* pt to offset fixed UrgencyBar + Navbar */}
        <HeroSection data-id="element-179" />
        <StatsBar data-id="element-180" />
        <ScenarioSection data-id="element-181" />
        <PainPoints data-id="element-182" />
        <ImpactQuote data-id="element-183" />
        <ExplanationSection data-id="element-184" />
        <MethodSection data-id="element-185" />
        <ProductSection data-id="element-186" />
        <BonusSection data-id="element-187" />
        <PricingSection data-id="element-188" />
        <ForWhoSection data-id="element-189" />
        <AuthorSection data-id="element-190" />
        <FinalCTA data-id="element-191" />
        <FAQSection data-id="element-192" />
      </main>
    </div>;
}